class Header {
	constructor() {

		this.headerMain = document.querySelector(".header-main");

		ScrollTrigger.create({
			start: "top -100",
			end: 9999999,
			toggleClass: {
				className: 'header-main-scrolled',
				targets: this.headerMain
			}
		});

		const showAnim = gsap.from('.header-main', {
			yPercent: -100,
			paused: true,
			duration: 0.2,
			ease: 'expo.out'
		}).progress(1);

		document.addEventListener('wheel', e => {
			if (e.deltaY > 30) {
				showAnim.reverse();
			} else if (e.deltaY < -30) {
				showAnim.play();
				if (window.scrollY > 100) {
					this.headerMain.classList.add("has-background");
				} else {
					this.headerMain.classList.remove("has-background");
				}
			}
		});

		setTimeout(() => {
			if (window.scrollY) {
				showAnim.reverse();
			}
		}, 500);
	}
}
